import React from "react";
import { colors } from "./variable";

type Position = any;
type TextAlign = any;

export interface ProgressProp {
  bgcolor: colors["value"] | string;
  completed: number;
  className?: string;
}

const ProgressBar = ({ bgcolor, completed, className }: ProgressProp) => {
  const containerStyles = {
    height: 4,
    width: "100%",
    alignSelf: "center",
    backgroundColor: "rgba(204, 204, 204, .5)",
    borderRadius: 50,
    position: "relative" as Position,
    margin: "0rem 0rem 0rem 0rem",
  };

  const fillerStyles = {
    height: "100%",
    width: `${completed > 100 ? 100 : completed}%`,
    backgroundColor: bgcolor,
    borderRadius: "inherit",
    textAlign: "right" as TextAlign,
    transition: "1s ease 0.3s",
  };

  const labelStyles = {
    padding: 7,
    color: "white",
    fontWeight: "bold",
  };

  return (
    <div className={className} style={containerStyles}>
      <div style={fillerStyles}>
        <span style={labelStyles}></span>
      </div>
    </div>
  );
};

export default ProgressBar;
